import type { ReactNode } from 'react'

export function Grid({ cols = 3, children }: { cols?: 2 | 3; children: ReactNode }) {
  const map = { 2: 'sm:grid-cols-2', 3: 'sm:grid-cols-2 lg:grid-cols-3' }
  return <div className={`grid gap-3 ${map[cols]}`}>{children}</div>
}

export function SectionLabel({ children }: { children: ReactNode }) {
  return <h2 className="mb-3 text-xs font-medium uppercase tracking-wider text-gray-400">{children}</h2>
}

export function StatCard({ label, value }: { label: ReactNode; value: ReactNode }) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
      <div className="mb-0.5 text-xs text-gray-500">{label}</div>
      <div className="text-lg font-semibold text-gray-900">{value}</div>
    </div>
  )
}

export function DateInput({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  return (
    <input
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="rounded-md border border-gray-300 bg-white px-2 py-1 text-sm"
    />
  )
}

// MoneyDelta renders a signed PLN delta with OLD's magnitude-based tone scale.
export function MoneyDelta({ value, digits = 1 }: { value: number | null; digits?: number }) {
  if (value === null || value === undefined) return <span className="text-gray-300">–</span>
  const abs = Math.abs(value)
  const tone =
    abs < 25
      ? 'text-gray-500'
      : abs < 75
        ? value > 0
          ? 'text-amber-700'
          : 'text-slate-700'
        : value > 0
          ? 'text-red-700'
          : 'text-slate-800 font-medium'
  const sign = value > 0 ? '+' : ''
  return (
    <span className={`font-mono ${tone}`}>
      {sign}
      {value.toFixed(digits)}
    </span>
  )
}
